import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TestGroup } from 'src/app/models/custom_test_model';
import { CustomTestService } from 'src/app/services/custom-test.service';
import { UserService } from 'src/app/services/user.service';
declare var Quill: any;

@Component({
  selector: 'app-groups-info',
  templateUrl: './groups-info.component.html',
  styleUrls: ['./groups-info.component.css']
})
export class GroupsInfoComponent implements OnInit {

  public groups: TestGroup[] = []
  public user;
  public selectedInfo: any;

  constructor(
    private customTestService: CustomTestService,
    private userService: UserService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.userService.getUser().subscribe( user => {
      this.user = user
    })
    this.customTestService.getTestGroups({active: true}).subscribe( resp => {
      this.groups = resp
    })
  }

  handleTestClick(){
    if (this.user.canUseCustomTests){
      this.router.navigate(['dashboard/createEvaluated'])
    }else{
      this.router.navigate(['dashboard/plans'], {queryParams: {view:'subscriptions'}})
    }
  }

  updateEditor(element: string, data){

    setTimeout(() => {
  
      var options = {
        modules: {
          toolbar: null
        },
        placeholder: '',
        theme: 'snow',
        readOnly: true,
        border: false
      };
      let editor = new Quill(element, options)
      editor.setContents(data);

    })

  }

}
